"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPathGroup = exports.apiPathGroup = exports.packageGroup = exports.subjectName = void 0;
exports.subjectName = 'Memo';
exports.packageGroup = 'memo';
exports.apiPathGroup = 'memos';
exports.routerPathGroup = 'memo';
